import axios from '@/utils/axios'
// 广告列表
export function listAd(query) {
    return axios({
        url: '/novel/novelClientUnlockConfigure/list',
        method: 'get',
        params: query
    })
}
export function details(query) {
    return axios({
        url: '/novel/novelClientUnlockConfigure/getUnlockConfigInfo',
        method: 'get',
        params: query
    })
}
// 添加
export function addAd(query) {
    return axios({
        url: '/novel/novelClientUnlockConfigure/addOrEditUnlockConfig/save',
        method: 'post',
        data: query
    })
}
// 删除
export function delAd(query) {
    return axios({
        url: '/novel/novelClientUnlockConfigure/delUnlockConfig/save',
        method: 'post',
        params: query
    })
}
// 广告状态
export function adStatus(query) {
    return axios({
        url: '/video/videoRecommendModule/getKeyStatus',
        method: 'get',
        params: query
    })
}
// 修改广告状态
export function updAdStatus(query) {
    return axios({
        url: '/video/videoRecommendModule/updateKeyStatus',
        method: 'get',
        params: query
    })
}
// 单篇小说解锁列表
export function bookUnlockList(query) {
    return axios({
        url: '/novel/novelClientUnlockConfigure/getNovelUnlockList',
        method: 'get',
        params: query
    })
}
// 获取播放状态
export function getAdStatus(query) {
    return axios({
        url: '/video/clientUnlockConfigure/getAdStatus',
        method: 'get',
        params: query
    })
}
// 设置播放状态
export function setAdStatus(query) {
    return axios({
        url: '/video/clientUnlockConfigure/updateAdStatus',
        method: 'get',
        params: query
    })
}